module.exports = {
    namespace: 'global',

    da: {
        forms: {
            name: 'Navn',
            firstName: 'Fornavn',
            lastName: 'Efternavn',
            email: 'Email',
            phoneNumber: 'Telefon',
            dateOfBirth: 'Fødselsdato',
            password: 'Kodeord',
            avatar: 'Profilbillede',
            short: 'Kort tekst',
            Notes: 'Noter',

            postcode: 'Postnummer',
            city: 'By',
            address: 'Adresse',

            preview: 'Forhåndsvisning',

            dragDropGuide: 'Slip filer her eller tryk for at uploade',

            project: {
                skill: 'Færdighed',
                name: 'Projektnavn',
                message: 'Besked',
            },

            company: {
                name: 'Virksomhedsnavn',
                vat: 'CVR-nummer',
            },

            student: {
                name: 'Studerende',
                short: 'Kort tekst',
            },
        },

        actions: {
            next: 'Næste',
            back: 'Tilbage',
            previous: 'Forrige',
            save: 'Gem',
            saveChanges: 'Gem ændringer',
            delete: 'Slet',
            remove: 'Fjern',
            update: 'Opdater',
            edit: 'Rediger',
            create: 'Opret',
            cancel: 'Annuller',
            send: 'Send',
            submit: 'Indsend',
            upload: 'Upload',
            download: 'Download',
            login: 'Log ind',
            logout: 'Log ud',
            select: 'Vælg',
            clear: 'Ryd',
            reset: 'Nulstil',
            close: 'Luk',
            contact: 'Kontakt',
            register: 'Registrer virksomhed',
            activate: 'Aktiver',
            deactivate: 'Deaktiver',
            signup: 'Tilmeld',
        },

        cookieNotice: {
            message: 'Her på Taskflex.dk er vi afhængige af cookies for at kunne tilbyde vores tjenester effektivt.',
            button: 'Jeg accepterer',
        },

        misc: {
            characters: 'tegn',
        },

        account: {
            student: 'Studerende',
            employee: 'Taskflex-Ansat',
            customer: 'Kunde',
        },
    },

    en: {
        forms: {
            name: 'Name',
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            phoneNumber: 'Phone',
            dateOfBirth: 'Date of birth',
            password: 'Password',
            avatar: 'Profile avatar',

            postcode: 'Post code',
            city: 'City',
            address: 'Address',

            preview: 'Preview',

            project: {
                skill: 'Skill',
                name: 'Project name',
                message: 'Message',
            },

            company: {
                name: 'Company name',
                vat: 'VAT-number',
            },
        },

        actions: {
            next: 'Next',
            back: 'Back',
            previous: 'Previous',
            save: 'Save',
            saveChanges: 'Save changes',
            delete: 'Delete',
            remove: 'Remove',
            update: 'Update',
            edit: 'Edit',
            create: 'Create',
            cancel: 'Cancel',
            send: 'Send',
            submit: 'Submit',
            upload: 'Upload',
            download: 'Download',
            login: 'Login',
            logout: 'Logout',
            select: 'Select',
            clear: 'Clear',
            reset: 'Reset',
            close: 'Close',
            contact: 'Contact',
            register: 'Register',
            activate: 'Activate',
            deactivate: 'Deactivate',
            signup: 'Sign up',
        },

        cookieNotice: {
            message: 'At Taskflex we are dependant on cookies, in order to provide our services effectively.',
            button: 'I accept',
        },

        misc: {
            characters: 'characters',
        },

        account: {
            student: 'Student',
            employee: 'Taskflex-Employee',
            customer: 'Customer',
        },
    },
};



// WEBPACK FOOTER //
// ./src/global/locales/index.js